<template>
  <div class="carousel">
    <button @click="prev" class="arrow left">&lt;</button>
    <transition name="fade" mode="out-in">
      <img
        :src="currentImageSrc"
        class="carousel-image"
        :class="{ 'carousel-image--contain': currentFit === 'contain' }"
        :key="currentIndex"
      >
    </transition>
    <button @click="next" class="arrow right">&gt;</button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  /** Optional list of image sources. When provided, used instead of default home carousel images. */
  imageList: {
    type: Array,
    default: () => null,
  },
});

const defaultImages = [
  require('@/assets/sherriJohnNancy.jpg'),
  require('@/assets/sherriPlus3.jpeg'),
  require('@/assets/sherriLaurynJohn.jpg'),
  require('@/assets/sherriAndLauryn.jpeg'),
  require('@/assets/sherriGoodPicture.jpg'),
  require('@/assets/IMG_0029.jpeg'),
  require('@/assets/IMG_0842.jpg'),
  require('@/assets/IMG_2074.jpg'),
  require('@/assets/IMG_5163.jpg'),
];

const images = computed(() => props.imageList && props.imageList.length ? props.imageList : defaultImages);

const currentIndex = ref(0);

const next = () => {
  currentIndex.value = (currentIndex.value + 1) % images.value.length;
};

const prev = () => {
  currentIndex.value = (currentIndex.value - 1 + images.value.length) % images.value.length;
};

function imageSrc(entry) {
  return typeof entry === 'string' ? entry : entry.src;
}

function imageFit(entry) {
  return typeof entry === 'object' && entry.fit ? entry.fit : 'cover';
}

const currentImageSrc = computed(() => imageSrc(images.value[currentIndex.value] ?? images.value[0]));
const currentFit = computed(() => imageFit(images.value[currentIndex.value] ?? images.value[0]));
</script>

<style scoped>
.carousel {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 700px;
  aspect-ratio: 700 / 380;
  margin: 1.5rem auto;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 4px;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.carousel-image--contain {
  object-fit: contain;
  object-position: center;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

.arrow.left {
  left: 0;
}

.arrow.right {
  right: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 600px) {
  .carousel {
    margin: 1rem auto;
  }

  .arrow {
    padding: 8px;
  }
}
</style>
